// THIS FILE IS GENERATED. DO NOT MODIFY.
// You probably want to modify ../../../codegen.mjs instead.

import { getPackageFiles } from "../getPackageFiles.js";
export const TEMPLATES = [
// React
{
  id: "template-react",
  label: "React",
  envPrefix: "VITE_",
  buildDirectory: "./dist",
  hidden: false,
  authless: false,
  files: {
    "1.x": getPackageFiles(import("@osdk/create-app.template.react")),
    "2.x": getPackageFiles(import("@osdk/create-app.template.react.beta"))
  }
},
// React (Public)
{
  id: "template-react-public",
  label: "React (Public)",
  envPrefix: "VITE_",
  buildDirectory: "./dist",
  hidden: false,
  authless: true,
  files: {
    "2.x": getPackageFiles(import("@osdk/create-app.template.react-public.beta"))
  }
},
// Expo
{
  id: "template-expo",
  label: "Expo",
  envPrefix: "EXPO_PUBLIC_",
  buildDirectory: "./dist",
  hidden: false,
  authless: false,
  files: {
    "2.x": getPackageFiles(import("@osdk/create-app.template.expo.v2"))
  }
},
// Vue
{
  id: "template-vue",
  label: "Vue",
  envPrefix: "VITE_",
  buildDirectory: "./dist",
  hidden: false,
  authless: false,
  files: {
    "1.x": getPackageFiles(import("@osdk/create-app.template.vue")),
    "2.x": getPackageFiles(import("@osdk/create-app.template.vue.v2"))
  }
},
// Tutorial: To do App
{
  id: "template-tutorial-todo-app",
  label: "Tutorial: To do App",
  envPrefix: "VITE_",
  buildDirectory: "./dist",
  hidden: true,
  authless: false,
  files: {
    "1.x": getPackageFiles(import("@osdk/create-app.template.tutorial-todo-app")),
    "2.x": getPackageFiles(import("@osdk/create-app.template.tutorial-todo-app.beta"))
  }
},
// Tutorial: To do AIP App
{
  id: "template-tutorial-todo-aip-app",
  label: "Tutorial: To do AIP App",
  envPrefix: "VITE_",
  buildDirectory: "./dist",
  hidden: true,
  authless: false,
  files: {
    "1.x": getPackageFiles(import("@osdk/create-app.template.tutorial-todo-aip-app")),
    "2.x": getPackageFiles(import("@osdk/create-app.template.tutorial-todo-aip-app.beta"))
  }
},
// TypeScript Library
{
  id: "template-typescript-library",
  label: "TypeScript Library",
  envPrefix: "",
  buildDirectory: "dist",
  hidden: true,
  authless: false,
  files: {
    "2.x": getPackageFiles(import("@osdk/create-app.template.typescript-library.beta"))
  }
}];